import React from 'react';
// @ts-ignore
import styles from './Table.module.scss';
import { ITableColumn } from '../../Models/Table/ITableColumn';
import { joinClasses } from '../../Utils/className.util';
import { useAppContext } from '../../Services/AppContext';
import FirstUpper from '../FirstUpper';
import Text from '../Base/Text/Text';

export default function TableColumn(props: ITableColumn) {
	const { title, role, style } = props;
	const { renderItem } = props;
	return (
		<div
			className={joinClasses([
				styles.flexRow,
				styles.tableColumn,
				'justify-content-center',
			])}
			role={role}
			style={style}>
			<Text tx={title} inline={true} firstUpper={true} />
		</div>
	);
}
